export default __webpack_public_path__ + "static/media/login-banner.e531017a.svg";